import { render, staticRenderFns } from "./WFConfigEdit.vue?vue&type=template&id=33bd61c4&scoped=true"
import script from "./WFConfigEdit.vue?vue&type=script&lang=js"
export * from "./WFConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd61c4",
  null
  
)

export default component.exports